export default Object.freeze({
  Details: 0,
  Approve: 1,
  Reject: 2,
  Complete: 3,
  ExecuteTask: 4,
  Sign: 5,
  Cancel: 6,
  Void: 7,
  SendNotifications: 8,
  EvaluateApprovers: 9,
  BackToStep: 10,
  ReassignTask: 11,
  ExecuteAutomaticAction: 12,
  History: 13,
  Continue: 14,
  AutoAssignTask: 15,
  GoToStep: 16,
  RemoveProcessInstance: 17,
  ClearError: 18,
  StartRequest: 19,
  GoToActionFromCustomCommand: 20,
  AIInteract: 21,
  AutoCancel: 28,
  AutoVoid: 29,
});
